export const PageHeadings = {
    DASHBOARD: "",
    USER_MANAGAMENT: "",
    CONTENT_MANAGAMENT: ""
};
